import React from 'react'
import { Link } from 'react-router-dom'
import { Container as ContainerBase, Grid as BaseGrid, styled } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import { Card as BaseCard } from '@chilecompra/react-kit/components'

export const ArrowForwardIcon = styled(ArrowForward)`
  &.MuiSvgIcon-root {
    aspect-ratio: 1/1;
    color: ${props => props.theme.palette.brand.primary};
    height: 18px;
    margin: auto -6px -4px -10px;
    vertical-align: top;

    &:hover {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-items: ${props => props.alignItems};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  width: ${props => props.width};
`

export const CardItem = styled(({ ...props }) => <div {...props} />)`
  align-items: center;
  display: flex;
  flex-direction: ${props => props.flexDirection};
  justify-content: center;
  padding: ${props => props.padding};
`

export const Column = styled(({ ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: 0;
    width: ${props => props.width};
  }
`

export const ColumnChart = styled(({ ...props }) => <BaseGrid item {...props} />)`
  align-content: ${props => props.alignContent};
  display: flex;
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  flex-wrap: ${props => props.flexWrap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width};
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <BaseGrid container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  margin: ${props => props.margin};
  width: 82px;
`

export const RedirectLink = styled(Link)`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    & svg {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`

export const Root = styled(ContainerBase)`
  padding: 0;
  &.MuiContainer-root {
    width: 100%;
  }
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  align-items: ${props => props.alignItems};
  flex-wrap: ${props => props.flexWrap};
  gap: ${props => props.gap};
  justify-content: ${props => props.justifyContent};
  margin-bottom: 10px;
  text-align: ${props => props.textAlign};
  width: ${props => props.width};

  @media (max-width: 744px) {
    flex-wrap: wrap;
    gap: 0;
  }
`

export const RowChart = styled(({ ...props }) => <BaseGrid container {...props} />)`
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 4px;
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width};
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  overflow: visible;
  margin: 5px 20px 10px 20px;
  ${props => props.theme.breakpoints.up('md')} {
    margin: 5px 30px 10px 20px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 310px;
    margin: 5px 10px 10px;
  }
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`
